var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 93.25 93.25" },
      attrs: {
        id: "Capa_1",
        height: "12pt",
        version: "1.1",
        viewBox: "0 0 93.25 93.25",
        width: "12pt",
        x: "0px",
        "xml:space": "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        y: "0px",
      },
    },
    [
      _c("g", [
        _c("path", {
          attrs: {
            d: "M78.354,14.375h4.967V0H46.686h-0.121H9.93v14.375h4.967c2.073,15.778,10.841,28.397,22.17,32.25\n\t\tc-11.329,3.854-20.098,16.473-22.171,32.25H9.929V93.25h36.635h0.121H83.32V78.875h-4.967c-2.073-15.777-10.841-28.396-22.17-32.25\n\t\tC67.512,42.772,76.28,30.153,78.354,14.375z M52.837,40.97c-0.432,4.025-0.703,18.347,3.969,20.058\n\t\tc10.768,4.183,14.865,16.595,14.865,16.595H21.579c0,0,4.098-12.412,14.865-16.595c4.672-1.711,4.399-16.032,3.969-20.058\n\t\tc-12.881-3.018-18.485-17.397-18.485-17.397h49.396C71.322,23.572,65.718,37.952,52.837,40.97z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }